module.exports = __webpack_public_path__ + "media/shippy/business-1681b74e.svg";